import React, { useEffect } from "react";
import Routes from "./Routes";

function App() {
    return (
        <div className="bg-purple-100 min-h-screen">
            <Routes />
        </div>
    );
}

export default App;
